import React, { useCallback } from 'react';
import SVPButton from 'src/components/SVPButtons/SVPButton';
import { TextField } from '@framework-controls/core';
import { strings } from 'src/localization/index';
import css from './ManualWrite.module.scss';
import { VehicleRec, ascFormEngagementInput } from 'src/models';
import { ascFormEngagement } from 'src/helpers/EventHelper/EventHelper';

export interface IProps {
    // Passdown flexbox class name
    className: string;
    vehicles: VehicleRec[];
    selectedVehicle: string | undefined;
    // Adds the custom issue to our diagnoses list
    addDiagnosis: (title: string, additionalComments: string) => void;
    // Handles the issue in the text field
    manualIssue: string;
    setManualIssue: (issue: string) => void;
    theme?: string;
}

const ManualWrite = (props: IProps) => {
    const blurHandler = useCallback(() => {
        const ascFormEngagementInp: ascFormEngagementInput = {
            pageType: 'service',
            commType: 'form',
            commStatus: 'engage',
            elementText: '',
            department: 'service',
            formName: 'Service_Portal_2',
            formType: 'service_appointment',
        };
        ascFormEngagement(ascFormEngagementInp, props.vehicles, props.selectedVehicle);
    }, [props.vehicles, props.selectedVehicle]);

    return (
        <div className={props.className}>
            <h4 className={css.mobile} id='h2'>{strings.Write}</h4>
            <h4 className={css.desktop} id='h2'>{strings.Write}</h4>
            <h5 id='h3'>{strings.ManuallyWrite}</h5>
            <div className={css.comments}>
                <TextField
                    type='text'
                    value={props.manualIssue}
                    id='comments'
                    size='full'
                    multiline
                    onChange={(_, value) => props.setManualIssue(value)}
                    rows={5}
                    disableUnderline
                    onBlur={blurHandler}
                />
            </div>
            <div className={css.button + ' ' + css.mobile}>
                <SVPButton
                    id='addDiagnosisBtnMobile'
                    message={strings.AddIssueButton}
                    variant='secondaryBtn'
                    // plus
                    noArrow
                    handler={() => props.addDiagnosis(props.manualIssue, '')}
                    tooltip={strings.AddCustomTip}
                    theme={props.theme}
                />
            </div>
            <div className={css.button + ' ' + css.desktop}>
                <SVPButton
                    id='addDiagnosisBtnDesktop'
                    message={strings.AddIssueButton}
                    variant='secondaryBtn'
                    noArrow
                    handler={() => props.addDiagnosis(props.manualIssue, '')}
                    tooltip={strings.AddCustomTip}
                    theme={props.theme}
                />
            </div>
        </div>
    );
};


export default ManualWrite;